import { render, staticRenderFns } from "./leaving-message.vue?vue&type=template&id=73210daa&scoped=true&"
import script from "./leaving-message.vue?vue&type=script&lang=js&"
export * from "./leaving-message.vue?vue&type=script&lang=js&"
import style0 from "./leaving-message.vue?vue&type=style&index=0&id=73210daa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73210daa",
  null
  
)

export default component.exports